import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { WorkflowService } from '../service';
import { SensorFailure } from '../model';

@Injectable({
  providedIn: 'root'
})
export class GetSensorFailuresResolver implements Resolve<SensorFailure[]> {

  constructor(private workflowService: WorkflowService) { }

  resolve(): Observable<SensorFailure[]> {
    return this.workflowService.getSensorFailures();
  }
}
